import type { Recipe } from '@/entities/recipe/model/types';
import type { Room } from '@/entities/room/model/types';

/**
 * Checks if a service can be deleted based on its usage in recipes and rooms.
 */
export const canDeleteService = (
    serviceId: string, 
    recipes: Recipe[] | Record<string, Recipe[]>, 
    rooms: Room[] = []
): boolean => {
    // Flatten recipes if it's an object
    const recipesList = Array.isArray(recipes) 
        ? recipes 
        : Object.values(recipes).flat();

    // Check usage in recipes
    const usedInRecipes = recipesList.some(r => 
        r.layers && r.layers.some(l => l.serviceId === serviceId)
    );
    
    if (usedInRecipes) return false;

    // Check usage in rooms
    if (rooms && rooms.length > 0) {
        const isUsedInRooms = rooms.some(room => 
            room.items && room.items.some(item => item.serviceId === serviceId)
        );
        if (isUsedInRooms) return false;
    }

    return true;
};
